export default __webpack_public_path__ + "static/media/droid.de165dd8.svg";